<template>
    <v-dialog v-model="uploader.status" width="400">
        <v-card  class="pa-5">
            <form @submit.prevent="uploadImage">
                <v-label>Upload Image</v-label>
                <v-file-input name="image" label="Image Upload" outlined dense style="margin-left: -20px"></v-file-input>

                <v-row justify="end" class="pa-5">
                    <v-btn type="submit" :disabled="submitted" dense color="primary" small>Upload</v-btn>
                </v-row>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios"
import { bus } from "@/main"
export default {
    data () {
        return {
            submitted: false,
            uploader: {
                status: false,
                type: null,
                indexes: null
            }
        }
    },
    created () {
        bus.$on("uploadImage", data => {
            this.uploader.status = true
            this.uploader.type = data.type
            this.uploader.indexes = data.indexes
        })
    },
    methods:
    {
        async uploadImage () {
            this.submitted = true
            const { image } = Object.fromEntries(new FormData(event.target))
            const { indexes, type } = this.uploader
            const { element, column, data } = indexes

            const formData = new FormData()
            formData.append("image", image)

            const response = await axios.post("/cms/upload-image-for-builder", formData)
            if (type == "text-image") {
                this.elements[element].image = response.data
            }
            else if (type == "imagecard") {
                this.elements[element].columns[column].data[data].image = response.data
            }
            else if (type == "dropdown") {
                this.elements[element].columns[column].data[data].image = response.data
            }

            this.submitted = false
            this.uploader.status = false

            this.$emit("uploadComplete", true)
        }
    }
}
</script>
